// @flow

import React from 'react';
import {
  PerformancesContainer,
  SongDescription,
  Tag,
  TagsWrapper,
  VideoWrapper,
  VideosContainer,
  VideoTitle,
} from './style';
import { HotspotVideo } from '../HotspotVideo';


type Props = {
  artistName: string,
  performances: Array<Object>,
  selectedCelebration: string,
};

export const CelebrationPerformances = ({
  artistName,
  performances,
  selectedCelebration,
}: Props) => (
  <PerformancesContainer>
    <VideosContainer>
      {performances.filter((performance) => performance.videoTags
        .some((tag) => tag.tag === selectedCelebration))
        .map((performance, index) => {
          // Determine if this is a learning video or performance video based on the image filename
          const isLearningVideo = !performance.videoImage.includes('concert');
          const videoTitle = isLearningVideo 
            ? `Learn "${performance.songTitle}"`
            : `Watch ${performance.artistName} perform "${performance.songTitle}"`;
          
          return (
            <VideoWrapper key={index}>
              <VideoTitle>{videoTitle}</VideoTitle>
              <HotspotVideo
                videoImage={performance.videoImage}
                vimeoLink={performance.videoLink}
                artistName={artistName}
                songTitle={performance.songTitle}
              />
              <TagsWrapper>
                {[...performance.videoTags]
                  .sort((a, b) => {
                    if (b.tag === selectedCelebration) return 1;
                    if (a.tag === selectedCelebration) return -1;
                    return 0;
                  })
                  .map((tag) => (
                    <Tag className={tag.tag === selectedCelebration ? 'active' : ''}>{tag.tag}</Tag>
                  ))}
              </TagsWrapper>
              <SongDescription>{performance.songDescription || ''}</SongDescription>
            </VideoWrapper>
          );
        })}
    </VideosContainer>
  </PerformancesContainer>
);
